import { createContext, useContext } from 'react'
import type { TrailSource } from '@/lib/auditTrailSources'

/**
 * Opens a linked item's audit trail in the pop-up (z8nrz7dq6q). Kept apart from
 * the dialog itself: the table renders the links, the links need this, and the
 * dialog renders the table — one module holding all three would be circular.
 */
export interface AuditTrailDialogApi {
  open: (source: TrailSource) => void
  /** The trail on screen, so a link to it renders as text rather than re-opening it. */
  current: TrailSource | null
}

export const AuditTrailDialogContext = createContext<AuditTrailDialogApi | null>(null)

/** Null outside the provider — links then fall back to opening the item's page. */
export function useAuditTrailDialog(): AuditTrailDialogApi | null {
  return useContext(AuditTrailDialogContext)
}
